import { render, staticRenderFns } from "./CAAndAP.vue?vue&type=template&id=37d36584&"
import script from "./CAAndAP.vue?vue&type=script&lang=js&"
export * from "./CAAndAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports